<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import config from '../public/config/config'
export default {
  destroyed () {
    sessionStorage.clear()
  },
  created () {
    document.title = config.title
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
  -webkit-box-direction: normal;
  -webkit-font-smoothing: antialiased;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

a {
  text-decoration: none;
  outline: none;
  color: #ffffff;
}

.cu-btn {
  cursor: pointer;
}
</style>
